import React from "react";
import "../Css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      {/* Glow Effect */}
      <div className="footer-glow"></div>

      <div className="footer-container">
        {/* ===== TOP GRID ===== */}
        <div className="footer-grid">
          {/* LOGO & DESCRIPTION */}
          <div className="footer-brand">
            <h2 className="footer-logo">
              Elite<span>Nova</span>
            </h2>

            <p>
              Building digital solutions for modern businesses.
            </p>

            {/* Social Icons */}
            <div className="footer-socials">
              <a href="/">🌐</a>
              <a href="/">📘</a>
              <a href="/">📸</a>
              <a href="/">💼</a>
            </div>
          </div>

          {/* SERVICES */}
          <div className="footer-links">
            <h3>Services</h3>

            <ul>
              <li>
                <a href="/">Web Development</a>
              </li>

              <li>
                <a href="/">E-commerce</a>
              </li>

              <li>
                <a href="/">UI/UX Design</a>
              </li>
            </ul>
          </div>

          {/* COMPANY */}
          <div className="footer-links">
            <h3>Company</h3>

            <ul>
              <li>
                <a href="/">About</a>
              </li>

              <li>
                <a href="/">Portfolio</a>
              </li>

              <li>
                <a href="/">Contact</a>
              </li>
            </ul>
          </div>

          {/* PRODUCTS */}
          <div className="footer-links">
            <h3>Products</h3>

            <ul>
              <li>
                <a href="/">Munafa</a>
              </li>

              <li>
                <a href="/">Solutions</a>
              </li>

              <li>
                <a href="/">Pricing</a>
              </li>
            </ul>
          </div>
        </div>

        {/* ===== BOTTOM ===== */}
        <div className="footer-bottom">
          <p>
            © 2024 EliteNova. All rights reserved.
          </p>

          <div className="footer-bottom-links">
            <a href="/">Privacy Policy</a>
            <a href="/">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;